module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/key-e8b83dcbaa63dc1b5bd877fc29373feb.png";